import React from 'react';
import ClientNameHeader from './ClientNameHeader'
import ClientAccountInformation from './ClientAccountInformation'
import ClientSecurityInformation from './ClientSecurityInformation'
import ClientAccountHistory from './ClientAccountHistory'
import './ClientInfo.scss'

const ClientBasicPersonalInformation = (props) => {

    return (
        <div id="basic-personal-info" className="content-grid">
            <ClientNameHeader client={props.client} />
            <ClientAccountInformation client={props.client} />
            <ClientSecurityInformation  />
            <ClientAccountHistory client={props.client} />
        </div>
    );
}

ClientBasicPersonalInformation.whyDidYouRender = false;

export default ClientBasicPersonalInformation